

















import Vue from "vue";
import { Component } from "vue-property-decorator";
import { version } from "../../package.json";

@Component
export default class SurveyLayout extends Vue {
  version!: string;
  created() {
    this.version = version;
  }
}
